import React, { useEffect,useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
const { Header, Sider, Content } = Layout;
const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  useEffect(() => {
    // Retrieve user details from local storage
    const userData = localStorage.getItem("user");
    
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);
  const handleSignout = () => {
    // Clear local storage
    localStorage.clear();
    // Redirect to the sign-in page or perform other sign-out actions
    // navigate('/signin');
  };
  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">TP</span>
            <span className="lg-logo">Two App</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: "",
              
              label: "Dashboard",
            },
            {
              key: "Member",
              
              label: "Member",
              children: [
                {
                  key: "AddMember",
                  
                  label: "Add-Member",
                  children: [
                    {
                      key: "Add-Member",
                      
                      label: "Single Member",
                    },

                    {
                      key: "bulk-Member",
                      
                      label: "Multiple Member",
                    }
                    
                  ]
                },
                {
                  key: "Member-list",
                  
                  label: "Member List",
                }
              ],
            },
            {
              key: "Update-Circular",
              
              label: "Update Circular",
              children: [
                {
                  key: "Add-Update",
                  
                  label: "Add Update",
                },
                {
                  key: "Update-list",
                  
                  label: "Update List",
                },
                {
                  key: "Add-Circular",
                  
                  label: "Add Circular",
                },
                {
                  key: "Circular-list",
                  
                  label: "Circular List",
                }
              ],
            },
            {
              key: "Board-Member",
              
              label: "Board Member",
              children: [
                {
                  key: "Add-Boards",
                  
                  label: "Add-Member",
                  
                },
                {
                  key: "Boards-list",
                  
                  label: "Member List",
                }
              ],
            },
            {
              key: "Chapters",
              
              label: "Chapters",
              children: [
                {
                  key: "Add-Chapters",
                  
                  label: "Add Chapters",
                  
                },
                {
                  key: "Chapters-list",
                  
                  label: "Chapters list",
                }
              ],
            },
            {
              key: "Live Appointment",
              
              label: "Live Appointment",
              children: [
                {
                  key: "Live-Appointment",
                  
                  label: "Live Appointment",
                  
                },
                {
                  key: "Appointment-List",
                  
                  label: "Appointment List",
                }
              ],
            },

          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
           

            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
                <img
                  width={32}
                  height={32}
                  src={user ? user.avatar : "https://icon-library.com/images/admin-icon/admin-icon-12.jpg"} // Use user's avatar if available
                  alt={user ? user.name : ""}
                />
              </div>
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5 className="mb-0">{user.name}</h5>
                <p className="mb-0">{user.email}</p>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    onClick={handleSignout}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                    onClick={handleSignout}
                  > 
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
